'use strict'
import { request } from '../../plugins/http'

export default async (user) => {
    return await request.delete(`/usuario?email=${user.EMAIL}&personId=${user.PESSOA_ID}&userId=${user.USUARIO_ID}&companyUserId=${user.EMPRESA_USUARIO_ID}`)
}